import { z } from 'zod';

// The SALE / RENTAL axis shared across contexts: a property's marketing
// type and a deal's type are the same closed set, so they reference one
// schema to stay in lockstep. en-US tokens per ADR 0009; German labels
// live in `packages/i18n`.
export const TRANSACTION_TYPES = ['SALE', 'RENTAL'] as const;

export const TransactionTypeSchema = z.enum(TRANSACTION_TYPES);

export type TransactionType = z.infer<typeof TransactionTypeSchema>;
